/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const TabFragment = {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
  TabComponent: gql`
    fragment TabQuery on tabComponent_Entry {
      tabbedContentTitle
      tab {
        ... on tabBlock_Entry {
          isActive
          tabTitle {
            html
          }
        }
      }
      tabAccordion1 {
        ... on tabAccordion1Block_Entry {
          itemDescription {
            html
          }
          accordionSectionTitle: accordionSectionTitle2 {
            html
          }
          itemTitle {
            html
          }
          showDescription
        }
      }
      tabAccordion2 {
        ... on tabAccordion2Block_Entry {
          itemDescription {
            html
          }
          accordionSectionTitle: accordionSectionTitle3 {
            html
          }
          itemTitle {
            html
          }
          showDescription
        }
      }
      tabAccordion3 {
        ... on tabAccordion3Block_Entry {
          itemDescription {
            html
          }
          accordionSectionTitle: accordionSectionTitle4 {
            html
          }
          itemTitle {
            html
          }
          showDescription
        }
      }
      tabAccordion4 {
        ... on tabAccordion4Block_Entry {
          itemDescription {
            html
          }
          accordionSectionTitle: accordionSectionTitle5 {
            html
          }
          itemTitle {
            html
          }
          showDescription
        }
      }
      styles
      typeHandle
    }
  `,
};
